import PropTypes from "prop-types";
import { Info } from "lucide-react";
import "../../styles/admin-base.css";

export default function AIBadge({ className = "", showTooltip = true, model = "OpenAI GPT-4" }) {
  const label = (
    <span className={`admin-chip is-blue ${className}`.trim()}>
      AI-suggested
      {showTooltip ? <Info size={14} /> : null}
    </span>
  );

  if (!showTooltip) {
    return label;
  }

  return (
    <span title={`Generated by ${model}`}>{label}</span>
  );
}

AIBadge.propTypes = {
  className: PropTypes.string,
  showTooltip: PropTypes.bool,
  model: PropTypes.string,
};
